export const CURRENCY_SHOW_RESET = 'CURRENCY_SHOW_RESET'
export const CURRENCY_SHOW_SET_ERROR = 'CURRENCY_SHOW_SET_ERROR'
export const CURRENCY_SHOW_SET_RETRIEVED = 'CURRENCY_SHOW_SET_RETRIEVED'
export const CURRENCY_SHOW_TOGGLE_LOADING = 'CURRENCY_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/currency/show/mutation_types.js